"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var SignalPatterns;

(function (SignalPatterns) {
  SignalPatterns["default"] = "GREY[\"400\"]";
  SignalPatterns["success"] = "UTILITY.SUCCESS";
  SignalPatterns["danger"] = "UTILITY.ERROR";
  SignalPatterns["warning"] = "UTILITY.WARN";
  SignalPatterns["informational"] = "UTILITY.ACTION";
})(SignalPatterns || (SignalPatterns = {}));

var sonar = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));

var makeSignalPatternStyles = function makeSignalPatternStyles(pattern, theme) {
  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(SignalPatterns[pattern]), theme));
};

var makeHaloStyles = function makeHaloStyles(pattern, theme) {
  return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  box-shadow: 0 0 0.5rem\n    ", ";\n"], ["\n  box-shadow: 0 0 0.5rem\n    ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(SignalPatterns[pattern]), theme));
};

var makeSonarStyles = function makeSonarStyles(pattern, theme) {
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  animation: ", " 2s infinite ease-in-out;\n  box-shadow: 0 0 0.5rem\n    ", ";\n"], ["\n  animation: ", " 2s infinite ease-in-out;\n  box-shadow: 0 0 0.5rem\n    ", ";\n"])), sonar, (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(SignalPatterns[pattern]), theme));
};

var makeNotificationStyles = function makeNotificationStyles(hasLabel) {
  if (hasLabel) {
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      outline: 0.125rem solid white;\n      padding: 0 0.25rem;\n      min-height: 1rem;\n      min-width: 1rem;\n      border-radius: 0.75rem;\n      color: ", ";\n\n      &::after {\n        content: none;\n      }\n    "], ["\n      outline: 0.125rem solid white;\n      padding: 0 0.25rem;\n      min-height: 1rem;\n      min-width: 1rem;\n      border-radius: 0.75rem;\n      color: ", ";\n\n      &::after {\n        content: none;\n      }\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
    });
  }

  return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n    border: 0.125rem solid white;\n    width: 0.625rem;\n    height: 0.625rem;\n  "], ["\n    border: 0.125rem solid white;\n    width: 0.625rem;\n    height: 0.625rem;\n  "])));
};

var makeIsInverseStyles = function makeIsInverseStyles(hasLabel) {
  if (hasLabel) {
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      outline: none;\n      background: ", ";\n      color: ", ";\n    "], ["\n      outline: none;\n      background: ", ";\n      color: ", ";\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.DARK", theme);
    });
  }

  return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n    border: none;\n    width: 0.375rem;\n    height: 0.375rem;\n    min-width: revert;\n    background: ", ";\n  "], ["\n    border: none;\n    width: 0.375rem;\n    height: 0.375rem;\n    min-width: revert;\n    background: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
  });
};

exports.Root = styled_components_1.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['pattern', 'isHalo', 'isSonar', 'isNotification', 'hasLabel', 'isInverse'].includes(prop);
  }
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 0.5rem;\n  min-width: 0.5rem;\n  border-radius: 50%;\n  ", ";\n\n  &::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    ", ";\n    ", ";\n  }\n\n  ", ";\n  ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 0.5rem;\n  min-width: 0.5rem;\n  border-radius: 50%;\n  ", ";\n\n  &::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    ", ";\n    ", ";\n  }\n\n  ", ";\n  ", ";\n"])), function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makeSignalPatternStyles);
}, function (props) {
  return props.isSonar && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makeSonarStyles);
}, function (props) {
  return props.isHalo && (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makeHaloStyles);
}, function (_a) {
  var isNotification = _a.isNotification,
      hasLabel = _a.hasLabel;
  return isNotification && makeNotificationStyles(hasLabel);
}, function (_a) {
  var isInverse = _a.isInverse,
      hasLabel = _a.hasLabel;
  return isInverse && makeIsInverseStyles(hasLabel);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;